import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegExp } from 'src/app/core/config/regex';
import { QuestionCategory } from 'src/app/shared/models/course';
import { Message } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';

@Component({
  selector: 'app-question-category-crud',
  templateUrl: './question-category-crud.component.html',
  styleUrls: ['./question-category-crud.component.scss']
})
export class QuestionCategoryCrudComponent implements OnInit {

  @Input() questionCategory: QuestionCategory;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public questionCategoryForm: FormGroup;
  public submitted: boolean = false;
  public submittedCourseSlide: boolean = false;
  private modified: boolean = false;
  public statuses: string[] = [];
  
  constructor(private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private commonService: CommonService,
    private courseService: CourseService,
    private toaster: ToastrService,) { }

  ngOnInit(): void {
    this.setQuestionCategoryForm(this.questionCategory);
    this.getQuestionCategoryStatus();
  }

  public setQuestionCategoryForm(questionCategory?: QuestionCategory) {
    if (!questionCategory) {
      questionCategory = {
        id: null,
        name: '',
        label: '',
        notes: '',
        disabled: false,
        approvalStatus: "DRAFT",
      } as QuestionCategory;
    }
    this.questionCategoryForm = this.fb.group({
      id: this.fb.control(questionCategory.id),
      name: this.fb.control(questionCategory.name, [Validators.required,Validators.pattern(RegExp.name)]),
      label: this.fb.control(questionCategory.label, Validators.pattern(RegExp.label)),
      notes: this.fb.control(questionCategory.notes,Validators.pattern(RegExp.label)),
      disabled: this.fb.control(questionCategory.disabled),
      approvalStatus: this.fb.control(questionCategory.approvalStatus, [Validators.required]),
    });

    this.questionCategoryForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.questionCategoryForm.controls;
  }

  public saveQuestionCategory(inProgress?: any) {
    this.submitted = true;
    if (this.questionCategoryForm.valid) {
      const questionCategory = this.questionCategoryForm.value as QuestionCategory;
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `question Category  has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (questionCategory.id) {
        this.courseService.updateQuestionCategory(questionCategory.id, questionCategory).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.passEntry.emit(response);
              this.toaster.success(response.text);
              this.activeModal.close(false);
              inProgress.value = false;
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, response.text);
            }
            this.submitted = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      } else {
        this.courseService.createQuestionCategory(questionCategory).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.passEntry.emit(response);
              this.toaster.success(response.text);
              this.activeModal.close(false);
              inProgress.value = false;
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, response.text);
            }
            this.submitted = false;
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
          },
        });
      }
    }
  }
  
  private getQuestionCategoryStatus() {
    this.courseService.getApprovalStatus().subscribe((statuses) => {
      this.statuses = statuses;
    });
  }

public getBadgeClassForStatus(status: string): string {
  switch (status?.toUpperCase()) {
    case 'DRAFT':
      return 'badge bg-secondary text-white rounded-pill';
    case 'IN_REVIEW':
      return 'badge bg-info text-white rounded-pill';
    case 'REVIEWED':
      return 'badge bg-warning text-dark rounded-pill';
    case 'RELEASED':
      return 'badge bg-success text-white rounded-pill';
    default:
      return 'badge bg-light text-dark rounded-pill';
  }
}

public formatStatus(label: string): string {
  return label
    ?.toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}
  
}
